import MuiTextField from "@mui/material/TextField";

/**
 * Facade over MUI TextField. Customize defaults here (size, variant, margin, etc.).
 */
export default function TextField(props) {
  return <MuiTextField {...props} />;
}
